import {forEach} from "lodash";

// pre load image
export const preLoadImage = path => {
  return new Promise((resolve, reject) => {
    let image = new Image()
    image.src = path;
    image.onload = () => {
      image = null;
      resolve();
    };
    image.onerror = () => {
      reject();
    }
  })
}

export const preLoadImageList = (pathList = []) => {
  return forEach(pathList, (path) => preLoadImage(path));
}
